export const imageResize = (file, size) => {
  return new Promise((resolve, reject) => {
    let maxWidth;
    let maxHeight;
    let oriWidth;
    let oriHeight;
    let width;
    let height;

  	if (100 < size && size <= 1800) {
  		maxHeight = size;
  		maxWidth = size;
  	}
  	else {
  		maxHeight = 1200;
  		maxWidth = 1200;
  	}

  	var reader = new FileReader();
  	reader.readAsDataURL(file);

  	reader.onload = function () {
  		var image = new Image();
  		image.src = this.result;

  		image.onload = function(){

  			oriWidth = image.width;
  			oriHeight = image.height;

  			if(oriWidth > oriHeight) {
          if (oriWidth > maxWidth) {
            width = maxWidth;
          }
  				else {
            width = oriWidth;
          }
  				height = Math.round(width * oriHeight / oriWidth);
  			}
  			else {
          if (oriHeight > maxHeight) {
            height = maxHeight;
          }
  				else {
            height = oriHeight;
          }
  				width = Math.round(height * oriWidth / oriHeight);
  			}

  			var canvas = document.createElement('canvas');

  			var context = canvas.getContext('2d');


  			canvas.width = width;
  			canvas.height = height;

  			//context.transform(1, 0, 0, 1, 0, 0);

  			context.drawImage(image, 0, 0, width, height);

        let uri = canvas.toDataURL('image/jpeg');
  			let bool = true;

  			resolve({bool, uri});
  		}

  		image.onerror = function() {
  			var bool = false;
  			var comment = '画像が読み込めませんでした。JEPG、PNG、GIFのファイルを選択してください'
  			reject({bool, comment});
  		}
    }

  });
}




export const imageRotate = (src, rotate) => {
  return new Promise((resolve, reject) => {

		var image = new Image();
		image.src = src;

		image.onload = function(){
      var oriWidth = image.width;
      var oriHeight = image.height;
      console.log(image.width);
			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');

      let width = oriWidth;
      let height = oriHeight;

      canvas.width = height;
      canvas.height = width;

      if (rotate === 'r') {
				context.transform(0, 1, -1, 0, height, 0);
			}
			else if (rotate === 'l') {
				context.transform(0, -1, 1, 0, 0, width);
			}
			context.drawImage(image, 0, 0, width, height);

      let uri = canvas.toDataURL('image/jpeg');
			let bool = true;

			resolve({bool, uri});
	  }
  });
}
